export const ButtonType = {
    Confirm: "Confirm",
    Icon: "Icon",
    Outlined: "Outlined",
    Primary: "Primary",
    Text: "Text",
    Warning: "Warning",
};
